/** Approved two-pose instruction, shared by DOM and in-world renderers. */
export const CONTROLLER_TRIGGER = {
  rest: new URL('./assets/controller-trigger-rest.webp', import.meta.url).href,
  pressed: new URL('./assets/controller-trigger-pressed.webp', import.meta.url).href,
  aspect: 3 / 2,
  cycleSeconds: 2.4,
} as const
